/** @type {(condition: any, message: string) => true} */
export const assert = (condition, message) => {
	const isOk = Boolean(condition);
	if (isOk) return isOk;
	throw new TypeError(message);
};

/** @type {(value: never, message: string | ((value: any) => string)) => never} */
export function assertNever(value, message) {
	const errorMessage = typeof message === "function" ? message(value) : message;
	throw new TypeError(errorMessage);
}
